<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm2"></a></p>
<div class="afmtx1"><div class="ctag1">In memory, we find the most complete release from the narrowness of presented time and place.... The picture is one of human beings confronted by a world in which they can be masters only as they ... discover ways of escape from the complete sway of immediate circumstances.</div>
<div> <br/></div><div class="ctag1">—F. C. Bartlett, <i>Remembering</i></div>
<div> <br/></div><div> <br/></div><div class="ctag1">What did you learn in school today, dear<br/> little boy of mine?<br/> What did you learn in school today, dear<br/> little boy of mine?<br/> I learned that war is not so bad<br/> I learned about the great ones we have had<br/> We fought in Germany and in France<br/> And I am someday to get my chance<br/> That’s what I learned in school today<br/> That’s what I learned in school.</div>
<div> <br/></div><div class="ctag1">—A song by Tom Paxton</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// stud_9781595587596_oeb_fm2_r1.vue?2ae1cd14